<template>
    <div class="main">
        <Layout>
            <Header v-on:goToPage="goToPage"></Header>
            <Layout class="body">
                <Sider
                    class="sidebar"
                    hide-trigger
                    width="200"
                    :class="{'collapsed': isSidebarCollapsed}"
                    :collapsed="isSidebarCollapsed"
                    @on-collapse="(state) => isSidebarCollapsed = state"
                    collapsible
                >
                    <div class="menu-header">
                        <span>工作台</span>
                        <Icon
                            type="md-menu"
                            class="collapse-btn"
                            @click="toggleSidebar"
                        />
                    </div>
                    <Menu ref="leftMenu" theme="light" width="auto" accordion :active-name="menuItem" :open-names="submenu"
                          @on-select="selectMenu" @on-open-change="openMenu">
                        <NavMenu :menuDatas="menuDatas"></NavMenu>
                    </Menu>
                </Sider>
                <Content class="content">
                    <Card :bordered="false">
                        <router-view :key="key"></router-view>
                    </Card>
                </Content>
            </Layout>
        </Layout>

        <forceEditPassword v-model="showForceEditPsdModal" :roleCodes="roleCodes"></forceEditPassword>
    </div>
</template>
<script>
import {reqGetLeftMenus} from '@/api/system-api'
import NavMenu from '@/components/menu/NavMenu.vue'
import Header from '@/components/Header/Header.vue'
import forceEditPassword from '@/components/Header/ForceEditPassword.vue'
import {jwtDecode} from 'jwt-decode';

export default {
    components: {NavMenu, Header, forceEditPassword},
    data() {
        return {
            menuDatas: [],
            menuItem: '',
            submenu: [],
            roleCodes: [],
            showForceEditPsdModal: false,
            isSidebarCollapsed: false
        }
    },
    methods: {
        selectMenu(name) {
            this.menuItem = name;
            sessionStorage.setItem('menuItem', name);
        },
        toggleSidebar() {
            this.isSidebarCollapsed = !this.isSidebarCollapsed;
        },
        openMenu(name) {
            this.submenu = name;
            sessionStorage.setItem('submenu', name);
        },
        //查询左侧树
        init() {
            reqGetLeftMenus({}).then((res) => {
                this.menuDatas = res.data.data;
                this.submenu = sessionStorage.getItem("submenu") ? [parseInt(sessionStorage.getItem("submenu"))] : [];
                this.menuItem = sessionStorage.getItem("menuItem") ? parseInt(sessionStorage.getItem("menuItem")) : '';
                if (!this.submenu || this.submenu.length < 1) {
                    this.submenu = [200];
                    this.menuItem = 200;
                    let routerName = '站内消息列表';
                    if (this.roleCodes.includes('adjustment')) {
                        this.submenu = [600];
                        this.menuItem = 600;
                        routerName = '调剂公示列表';
                    }

                    sessionStorage.setItem('submenu', this.submenu);
                    sessionStorage.setItem('menuItem', this.menuItem);
                    this.$router.push({name: routerName, query: {permissionId: this.menuItem}});
                }
                this.$nextTick(() =>{
                    this.$refs.leftMenu?.updateOpened();
                    this.$refs.leftMenu?.updateActiveName();
                })
            });
        },
        goToPage(name) {
            if (name === '站内消息列表') {
                this.submenu = [200];
                this.menuItem = 200;
                sessionStorage.setItem('submenu', this.submenu);
                sessionStorage.setItem('menuItem', this.menuItem);
                this.$router.push({name: '站内消息列表', query: {permissionId: 200, ts: new Date().getTime()}});
            }

            this.$nextTick(() =>{
                this.$refs.leftMenu?.updateOpened();
                this.$refs.leftMenu?.updateActiveName();
            })
        },
    },
    computed: {
        key() {
            return this.$route.path;
        }
    },
    mounted() {
        let token = sessionStorage.getItem('Authorization');
        this.roleCodes = jwtDecode(token).roleCode.split(',').map(role => role.trim()) || [];

        this.init();

        let isPsdChanged = sessionStorage.getItem('isPsdChanged');
        let isSupplier = this.roleCodes.includes('supplier');
        this.showForceEditPsdModal = (isSupplier && isPsdChanged === '0');
    }
}
</script>
